import Abbr from './Abbr';
import './abbr.scss';

export default Abbr;



// WEBPACK FOOTER //
// ./~/rp-react-common/src/Abbr/index.js